import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Unveiling } from './components/Unveiling';
import { Waitlist } from './components/Waitlist';
import { Product } from './components/Product';
import { Sensory } from './components/Sensory';
import { PerfectFor } from './components/PerfectFor';
import { LocalLaunch } from './components/LocalLaunch';
import { Instagram } from './components/Instagram';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-chocolate text-cream" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Unveiling data-id="element-4" />
          <Waitlist data-id="element-5" />
          <Hero data-id="element-6" />
          <Marquee data-id="element-7" />
          <Product data-id="element-8" />
          <Sensory data-id="element-9" />
          <PerfectFor data-id="element-10" />
          <LocalLaunch data-id="element-11" />
          <Instagram data-id="element-12" />
          <FAQ data-id="element-13" />
          <FinalCTA data-id="element-14" />
        </main>
        <Footer data-id="element-15" />
      </div>
    </LanguageProvider>;
}